<template>
<form class="mt-4">
    <div class="row col-xl-6 m-auto">
        <div class="col text-center position-relative" style="z-index: 1000;">
            <input type="text" class="form-control fs-2 text mainSearch" placeholder="Hotel, chain or place" v-model="searchString">
            <i class="position-absolute loader" v-if="isLoading">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 100 100" overflow="visible" fill="#454545">
                    <defs><rect id="spinner" x="46.5" y="40" width="7" height="20" rx="2" ry="2" transform="translate(0 -30)"></rect></defs>
                    <use xlink:href="#spinner" transform="rotate(0 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(30 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.08s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(60 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.16s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(90 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.24s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(120 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.32s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(150 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.4s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(180 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.48s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(210 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.56s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(240 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.64s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(270 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.72s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(300 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.8s" repeatCount="indefinite"></animate>
                    </use>
                    <use xlink:href="#spinner" transform="rotate(330 50 50)">
                        <animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.88s" repeatCount="indefinite"></animate>
                    </use>
                </svg>
            </i>
<!--            <i v-else class="position-absolute search-icon" @click="getNearestAirports">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">-->
<!--                    <path d="M0 0h24v24H0z" fill="none"/>-->
<!--                    <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/>-->
<!--                </svg>-->
<!--            </i>-->
            <div class="search-results position-absolute w-100" v-if="showResults">
                <div class="search-results-block d-flex justify-content-between" v-for="(value, name, index) in results">
                    <div class="search-group" v-if="value.length > 0">
                        <span>{{ getGroupTitle(name) }}</span>
                    </div>
                    <ul class="list-group text-start w-100">
                        <li class="list-group-item-action list-group-item p-3 pointer result big-results-item" v-for="result in value" @click.stop="goTo(result)"><div class="search-title">{{ result.title }}</div><div class="search-subtitle">{{ getSubTitle(result) }}</div></li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
    <div class="position-fixed h-100 w-100 top-0 start-0" v-if="showResults" @click="showResults = false"></div>
</form>
</template>

<script>
import axios from "axios";
export default {
    name: "SearchHome",
    data() {
        return {
            searchString: "",
            isLoading: false,
            timeout: null,
            results: [],
            showResults: false
        }
    },
    props: {
        ip: null
    },
    methods: {
        goTo(result) {
            switch (result.objecttype) {
                case 'city':
                    location.href = "/" + result.city_name.toLowerCase();
                    break;
                case 'hotel':
                    location.href = '/' + result.city_name.toLowerCase();
                    break;
            }
        },
        getSubTitle(item) {
            switch (item.objecttype) {
                case 'city':
                    return 'City in ' +item.country_name;
                case 'hotel':
                    return 'Hotel in ' + item.city_name + ', ' +item.country_name;
                case 'citychain':
                    return 'Hotel chain in ' + item.city_name + ', ' +item.country_name;
            }
        },
        getGroupTitle(title) {
            switch (title) {
                case 'search_result_header_places':
                    return 'Places';
                case 'search_result_header_chains':
                    return 'Chains';
                case 'search_result_header_hotels':
                    return 'Hotels';
            }
        },
        getNearestAirports() {
            this.isLoading = true;
            this.showResults = true;
            axios.post('/airport/nearest', { ip: this.ip }).then((res) => {
                if(res.data.success) {
                    this.results = res.data.airports;
                    this.isLoading = false;
                }
            })
        }
    },
    watch: {
        searchString(value) {
            if (value.length > 2) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.isLoading = true;
                    axios.post('/api/search', { "searchString": this.searchString}).then((res) => {
                        this.isLoading = false;
                        if(res.data.success) {
                            this.results = res.data.data;
                            this.showResults = true;
                        }
                    })
                }, 500);
            } else {
                this.isLoading = false;
                this.awaitingSearch = false;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.loader {
    top: 28px;
    right: 35px;
}
.search-icon {
    top: 28px;
    right: 35px;
}
.search-results {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.375rem;
}
.results {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    left: 0;
}
.big-results-item {
    background-color: #fff;
    cursor: pointer;
    color: #212529;
    &:hover{
         background-color: #eee;
     }
}
.pointer {
    cursor: pointer;
}
.search-group {
    min-width: 100px;
    padding-top: 10px;
}
.search-results-block {
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    &:last-child {
        border-bottom: 0;
    }

    .list-group-item {
        border-right: 0;
        border-radius: 0;
        &:first-child {
            border-top: 0;
        }
        &:last-child {
            border-bottom: 0;
        }
    }
}
.search-subtitle {
    font-size: 12px;
}
.mainSearch {
    height: auto;
    width: 100%;
    margin: 0;
    padding: 20px 30px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    font-size: 30px;
    text-overflow: ellipsis;
    color: rgba(50,50,50,.3);
    outline: 0;
    border-radius: 10rem;
    border: 0.05rem solid rgba(66,66,66,.5);
    transition: all .4s ease;
    box-shadow: 0 5px 15px rgb(0 0 0 / 8%);
}
</style>
